import React, { useEffect, useState, useContext, useMemo } from 'react';

import 'components/UploadAssetLibrary/UploadAssetLibrary.scss';

import Modal from 'components/Common/Modal/Modal';
import { TextInput } from 'components';
import Checkboxes from 'components/Common/Checkboxes/Checkboxes';
import Breadcrumbs, { IPages } from 'components/Common/Breadcrumbs/Breadcrumbs';
import { ASSETS_LIBRARY, parsePathFromArray } from '../util';
import { UserContext } from 'providers/UserProvider';
import { getBucketAssetFolder } from 'services/Api';
import FolderIcon from 'assets/icons/Icon-folder.svg';
import ArrowIcon from 'assets/icons/angle-right-gray.svg';

export interface IOptions {
  label: string;
}

export interface IFilterDropdowns {
  label: string;
  options: IOptions[];
}

export interface ISaveToAssetLibraryModal {
  headingText: string;
  bucket: any;
  model: string;
  options?: IOptions[];
  filterDropdowns?: IFilterDropdowns[];
  open: boolean;
  setOpen?: (open: boolean) => void;
  onSelect?: (params: any) => void;
}

const SaveToAssetLibraryModal: React.FC<ISaveToAssetLibraryModal> = props => {
  const { headingText, bucket, model, open, setOpen, onSelect } = props;

  const {
    user: { idToken },
  } = useContext(UserContext);

  const [folderPath, setFolderPath] = useState([model]);
  const [folderPathText, setFolderPathText] = useState(`/${model}/`);
  const [sandbox, setSandbox] = useState(false);
  const [activeFolders, setActiveFolders] = useState([]);

  useEffect(() => {
    const fetchFolderHandler = async () => {
      setActiveFolders([]);

      const folder_path = '/' + folderPath.map(p => p + '/').join('');
      setFolderPathText(folder_path);
      const response = await getBucketAssetFolder(
        idToken,
        bucket.key,
        ASSETS_LIBRARY.product_asset.apis.get_folder,
        { path: folder_path }
      );
      const { data: blobs } = response.data;

      const folders =
        folderPath.length > 0
          ? []
          : ASSETS_LIBRARY.product_asset.folders.map(f => ({ name: f }));
      for (const blob of blobs) {
        const subPathName = blob.path.substring(folder_path.length);
        if (subPathName === '') {
          continue;
        }
        const subPath = subPathName.split('/');
        const [name] = subPath;
        if (subPath.length >= 2) {
          // check to add child folder if missing
          if (folders.findIndex(f => name.localeCompare(f.name) === 0) === -1) {
            folders.push({ name });
          }
        }
      }
      setActiveFolders(folders);
    };
    fetchFolderHandler();
  }, [bucket.key, folderPath]);

  const onChooseFolderPath = () => {
    const folder_path = folderPathText
      .split('/')
      .map(p => p.trim())
      .filter(p => p);
    console.log('Choose #####=====', folder_path);
    setFolderPath(folder_path);
  };

  const onSubmit = e => {
    e.preventDefault();
    onSelect?.({
      path: parsePathFromArray(folderPath),
      sandbox: sandbox,
    });
    setOpen(false);
  };

  const pages = useMemo(() => {
    const pagesArray = [];
    let link = '/';
    for (let i = 0; i < folderPath.length; i += 1) {
      const p = folderPath[i];
      link += `/${p}`;
      const page: IPages = {
        title: p,
      };
      if (i < folderPath.length - 1) {
        page.link = link;
        page.onClick = () => setFolderPath(folderPath.slice(0, i + 1));
      }
      pagesArray.push(page);
    }
    if (folderPath.length > 0) {
      pagesArray.push({
        title: '<',
        link: '/',
        onClick: () => setFolderPath(folderPath.slice(0, folderPath.length - 1)),
      });
    }
    return pagesArray;
  }, [folderPath]);

  return (
    <div className='upload-asset-library'>
      <Modal
        modalHeading={headingText}
        modalBtnClose='Cancel'
        modalBtnActionLabel='OK'
        modalBtnActionHandler={onSubmit}
        backgroundColor='#fff'
        modalOpen={open}
        setModalOpen={setOpen}
      >
        <div className='upload-asset-library__body'>
          <h3 style={{ marginBottom: '5px' }}>Asset Library Folder</h3>
          <TextInput
            label=''
            name='folder_path'
            value={folderPathText}
            onChange={setFolderPathText}
          />
          <div
            style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
          >
            <div className='save-to-sandbox'>
              <Checkboxes checked={sandbox} onChange={() => setSandbox(!sandbox)} />
              Save to sandbox
            </div>
            <div>
              <button
                className='button-transparent-black button-smaller'
                onClick={onChooseFolderPath}
              >
                Choose
              </button>
            </div>
          </div>
          <Breadcrumbs pages={pages} />
          <div className='upload-asset-library__folders'>
            {activeFolders &&
              activeFolders.map(({ name }, idx) => (
                <div key={name} className='upload-asset-library__folder'>
                  <span
                    className='upload-asset-library__folder__heading-flex'
                    onClick={() => setFolderPath([...folderPath, name])}
                  >
                    <img
                      src={FolderIcon}
                      className='upload-asset-library__folder__folder-icon'
                      alt={name}
                    />
                    {name}
                  </span>
                  <div className='upload-asset-library__folder__arrow-icon'>
                    <img src={ArrowIcon} alt='Open' />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SaveToAssetLibraryModal;
